<template>
  <el-dialog
    id='setCollectionAccountDialog'
    :title="title"
    @close="closeDialog"
    :visible.sync="isShow"
    width="700px"
    :close-on-click-modal='false'
    :close-on-press-escape='false'
  >
    <div id="setCollectionAccount" v-loading = 'loading'>
        <div class='acc-style' v-if="active==='1'"><span class="acc-title">收款账户：</span><span class="acc-content">未设置</span></div>
        <div class='acc-style' v-if="active==='2'"><span class="acc-title">收款账户：</span><span class="acc-title">{{accountData.accountName}}/{{accountData.accountNumber}}</span></div>
        <div style="text-align: center;margin-top: 20px;">
          <el-button @click="closeDialog()" v-if="active==='1' || active==='2'">取消</el-button>
          <el-button type="primary" @click="toSetting('1')" v-if="active==='1'">去设置</el-button>
          <el-button type="primary" @click="toSetting('2')" v-if="active==='2'">修改</el-button>
        </div>
        <div v-if="active==='3'">
          <el-form label-width="100px"  class="demo-ruleForm" :model="infoForm" ref="infoForm">
            <el-form-item label="绑定手机号" class="phone-input">
              <el-input v-model="infoForm.mobile" disabled></el-input>
            </el-form-item>
            <el-form-item label="图片验证码" class="code-input">
              <el-input  v-model="infoForm.picSmsCode" :maxlength="4" placeholder="请输入图形验证码"></el-input><img class="picture-sms-code code-btn" @click="refreshPic" alt="" :src="src"/>
            </el-form-item>
            <el-form-item label="短信验证码" class="code-input">
              <el-input  v-model="infoForm.smsCode" :maxlength="6" placeholder="请输入短信验证码"></el-input><el-button class="sms-code-btn code-btn" @click="sendMessageSmsCode" :disabled="timeText >= 0">{{timeText >= 0 ? timeText + 's' : '获取验证码'}}</el-button>
            </el-form-item>
            <el-form-item label-width="0" class="form-btn">
              <el-button @click="resetForm('infoForm')">取消</el-button>
              <el-button type="primary" @click="toSetting('3')" v-if="active==='3'">下一步</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-show="active==='4'">
          <el-form label-width="100px"  class="demo-ruleForm" :model="form" ref="ruleform" :rules="formRules">
            <div class='acc-style mb20'><span class="acc-title">请填写您的支付宝账号</span></div>
            <el-form-item label="姓名" prop="accountName" class="phone-input">
              <el-input v-model.trim="form.accountName" maxlength="30" placeholder="请输入" key="accountName"></el-input>
            </el-form-item>
            <el-form-item label="账号" prop="accountNumber" class="phone-input">
              <el-input v-model.trim="form.accountNumber" maxlength="30" placeholder="请输入" key="accountNumber"></el-input>
            </el-form-item>
            <el-form-item label-width="0" class="form-btn">
              <el-button @click="resetForm('ruleform')">取消</el-button>
              <el-button type="primary" @click="submitForm('ruleform')">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
    </div>
  </el-dialog>
</template>

<script>
import netAPI from '@/api';
import Cookies from 'js-cookie';
import timeText from '@/mixins/timeText';
import { checkSmsCodeApi, checkVerifyCodeApi } from '@/api/systemModule/login';
export default {
  mixins: [timeText],
  props: {
    data: {
      type: Object
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let specStrKey = (rule, value, callback) => {
      if (!/^[\u4e00-\u9fa5 0-9()（）]*$/.test(value)) {
        callback(new Error('姓名仅支持汉字、数字、（）'));
      } else {
        callback();
      }
    };
    let specStr = (rule, value, callback) => {
      // eslint-disable-next-line no-useless-escape
      if (!/^[a-zA-Z0-9\@.]*$/.test(value)) {
        callback(new Error('账号仅支持字母、数字、@ . '));
      } else {
        callback();
      }
    };
    return {
      active: '1',
      timeText: '获取验证码',
      title: '理赔收款账户',
      isShow: this.value,
      loading: false,
      infoForm: {
        mobile: '',
        picSmsCode: '',
        smsCode: ''
      },
      form: {
        accountName: '',
        accountNumber: ''
      },
      formRules: {
        accountName: [
          { required: true, message: '姓名不能为空', trigger: ['change', 'blur'] },
          { validator: specStrKey, trigger: ['change', 'blur'] }
        ],
        accountNumber: [
          { required: true, message: '账号不能为空', trigger: ['change', 'blur'] },
          // { validator: specStr, trigger: ['change', 'blur'] }
        ]
      },
      src: '',
      accountData: {},
      activeCode: 'save'
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  created() {
    let time = Cookies.get('smsCode6');
    if (time) {
      let showTime = 60 - parseInt((new Date().getTime() - new Date(time).getTime()) / 1000);
      this.timeText = showTime;
      this.setText();
    }
  },
  mounted() {
    this.getAccountDetail();
  },
  methods: {
    // 获取收款账户详细信息
    getAccountDetail() {
      let params = {
        groupId: this.userMess.groupId,
        loginId: this.userMess.loginId
      };
      this.loading = true;
      netAPI.getAccountDetail(params).then(res => {
        if (res.success) {
          if (res.data) {
            this.active = '2';
            this.accountData = res.data;
            this.activeCode = 'update';
          } else {
            this.active = '1';
            this.activeCode = 'save';
          }
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    // 去设置
    toSetting(code) {
      if (code === '1') {
        this.active = '3';
        this.title = '设置收款账户';
        this.infoForm.mobile = this.userMess.userName;
        this.refreshPic();
      }
      if (code === '2') {
        this.active = '3';
        this.title = '修改收款账户';
        this.infoForm.mobile = this.userMess.userName;
        this.refreshPic();
      }
      if (code === '3') {
        // 校验短信验证码
        this.loading = true;
        checkVerifyCodeApi({
          mobile: this.userMess.userName,
          smsCode: this.infoForm.smsCode
        }).then(res => {
          if (res && !res.success && (res.hasOwnProperty('message') || res.hasOwnProperty('stackTrace'))) {
            this.$message.error(res.message || res.stackTrace);
          } else {
            this.active = '4';
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      }
    },
    // 获取图片验证码
    refreshPic() {
      netAPI.queryPicSmsCode().then(response => {
        if (response.base64Img && response.sessionId) {
          this.src = response.base64Img;
          this.sessionId = response.sessionId;
        } else {
          this.$message.error('服务器返回内容有误！');
        }
      });
    },
    // 获取短信验证码
    sendMessageSmsCode() {
      if (this.infoForm.picSmsCode === '') {
        this.$message({
          type: 'warning',
          message: '图片验证码不能为空'
        });
        return false;
      }
      checkSmsCodeApi({
        sessionId: this.sessionId,
        smsType: 11,
        graphicsCode: this.infoForm.picSmsCode
      }).then((res) => {
        if (res && res.status!=0) {
          this.$message.error(res.message || res.stackTrace);
          this.infoForm.picSmsCode = '';
          this.refreshPic();
        } else {
          let time = 60;
          Cookies.set('smsCode6', new Date(), { expires: (1 / (24 * 60)) });
          this.timeText = time;
          this.setText();
        }
      });
    },
    // 提交账户信息
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            accountName: this.form.accountName,
            accountNumber: this.form.accountNumber,
            groupId: this.userMess.groupId,
            loginId: this.userMess.loginId
          };
          this.loading = true;
          let accountApi = '';
          if (this.activeCode === 'save') {
            accountApi = netAPI.saveAccount;
          } else {
            accountApi = netAPI.updateAccount;
            params.id = this.accountData.id;
          }
          accountApi(params).then(res => {
            this.loading = false;
            if (res.success) {
              this.$message.success('保存成功');
              this.closeDialog();
            } else {
              this.$message.error(res.message || '保存失败');
            }
          }).catch(() => {
            this.loading = false;
            this.$message.error('保存失败');
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.closeDialog();
    },
    closeDialog() {
      this.isShow = false;
      this.$emit('close');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss">
#setCollectionAccountDialog{
  .el-dialog__body{
    padding: 40px;
  }
}
#setCollectionAccount .el-button--small {
  width: 100px;
}
#setCollectionAccount{
    .acc-style{
        text-align: center;
        .acc-title{
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 20px;
        }
        .acc-content{
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
        }
    }
    .demo-ruleForm{
        .el-form-item--small.el-form-item{
            width: 350px;
            margin: 0 auto 18px auto;
        }
        .phone-input .el-input{
            width: 246px;
        }
        .code-input .el-input{
            width: 152px;
        }
        .code-input .el-form-item__content{
            display: flex;
        }
        .code-btn{
            width: 88px;
            height: 32px;
            margin-left: 8px;
            cursor: pointer;
        }
        .form-btn{
            display: block;
            margin-left: 0;
            margin-top: 40px!important;
            text-align: center;
        }
    }
}
.mt10{
  margin-top: 10px;
}
.ml10{
  margin-left: 10px;
}
.mr10{
  margin-right: 10px;
}
.mb20{
  margin-bottom: 20px;
}
.mb40{
    margin-bottom: 40px;
}
.mt40{
    margin-top: 40px;
}
</style>
